/**
 * Sanitize user/HTML content for inject UIs.
 * Always HTML-escapes. Do not call CDN DOMPurify here — blocked CDNs previously
 * crashed notes rendering ("Notizen konnten nicht geladen werden").
 */
const sanitizeForInject = (value = '') => {
  const str = String(value ?? '')
  return typeof escapeHtml === 'function'
    ? escapeHtml(str)
    : str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
}
